export default __webpack_public_path__ + "static/media/Dec.21ad4d4c.svg";